(function() {
    'use strict';

    angular
        .module('app.servicios')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/servicios',
                config: {
                    templateUrl: 'app/servicios/list.html',
                    controller: 'servicios.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-servicio/:id?',
                config: {
                    templateUrl: 'app/servicios/edit.html',
                    controller: 'servicios.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
